<template>
    <div class="detailEdit-panel">
        <div class="detailEdit-box">
            <div class="box-oprerate">
                <template v-if="authEdit">
                    <el-button v-if="isEdit" class="btn" @click="handleSave">保 存</el-button>
                    <el-button v-else class="btn" @click="handleEdit">编 辑</el-button>
                    <el-button v-if="isEdit" class="btn" @click="handleEditCancel">取 消</el-button>
                    <el-button v-else class="btn" @click="handleClose(false)">关 闭</el-button>
                </template>
                <template v-else>
                    <el-button class="btn btn1" @click="handleClose(false)">关 闭</el-button>
                </template>
            </div>
            <div class="title font-color">地块详情</div>
            <div class="form">
                <div class="form-group" v-for="(key,index) in Object.keys(columnGroupData)" :key="'group'+index">
                    <div class="name font-color">{{key}}</div>
                    <div class="content">
                        <div class="content-item" v-for="(item,ind) in columnGroupData[key]" :key="'col'+key+ind">
                            <span>{{item.name}}</span>
                            <template v-if="isEdit">
                                <el-input v-if="key==='已建指标'||key==='基本信息'" class="input-disable" v-model="formData[item.field]" readonly></el-input>
                                <template v-else>
                                    <el-select v-if="item.type==='SELECT'" class="select" popper-class="select-options" :popper-append-to-body="false" v-model="formData[item.field]" :disabled="!isEdit">
                                        <el-option v-for="val in item.values" :key="val" :value="val" :label="val"></el-option>
                                    </el-select>
                                    <el-input v-else class="input" v-model="formData[item.field]" :placeholder="`请输入${item.name}`"></el-input>
                                </template>
                            </template>
                            <el-input v-else class="input" v-model="formData[item.field]" readonly></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="name font-color">附件</div>
                    <div v-if="isEdit" class="tip-limit">单个大小不超过100M</div>
                    <div class="filelist">
                        <span class="filelist-title">相册</span>
                        <div class="medias">
                            <el-upload
                                v-if="isEdit"
                                style="margin-right:8px;"
                                v-loading="picLoading"
                                multiple
                                action="#"
                                :auto-upload="false"
                                :show-file-list="false"
                                accept="image/*,video/mp4"
                                :on-change="handleUploadPic">
                                <i class="el-icon-plus pic-uploader-icon"></i>
                            </el-upload>
                            <template v-for="(item,index) in picList">
                                <!-- 图片处理 -->
                                <template v-if="item.type.indexOf('image/')>-1">
                                    <!-- 编辑状态 -->
                                    <div v-if="isEdit" class="medias-item" :key="index">
                                        <img class="img" :src="item.url" alt="" />
                                        <img class="medias-delete-icon" src="../../assets/images/digital/pic-delete.png" @click="handleDeletePic(index)"/>
                                    </div>
                                    <!-- 查看状态 -->
                                    <img v-else class="medias-item" style="cursor: pointer;" :key="index"
                                        :src="item.url" alt=""
                                        @click="handlePreviewClick(index, 'pic')"/>
                                </template>
                                <!-- 视频处理 -->
                                <div class="medias-item" v-else :key="'pic'+index" :style="isEdit?'':'cursor: pointer;'" @click="isEdit?null:handlePreviewClick(index, 'pic')"> 
                                    <video :src="item.url"></video>
                                    <img class="icon-play" src="../../assets/images/digital/icon-play.png">
                                    <img v-if="isEdit" class="medias-delete-icon" src="../../assets/images/digital/pic-delete.png" @click="handleDeletePic(index)"/>
                                </div>
                            </template>
                            
                        </div>
                        <span class="filelist-title">文件</span>
                        <div class="files">
                            <el-upload v-if="isEdit"
                                v-loading="fileLoading"
                                multiple
                                action="#"
                                :auto-upload="false"
                                :show-file-list="false"
                                accept="application/*,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                                :on-change="handleUploadFile">
                                <el-button class="file-uploader-btn">上传文档</el-button>
                            </el-upload>
                            <div class="file-item" v-for="(item,index) in fileList" :key="index">
                                <div class="file-name" :style="isEdit?'':'cursor: pointer;'" @click="isEdit?null:handlePreviewClick(index, 'file')">
                                    <span>{{item.name}}</span><img class="file-type-icon" :src="require('../../assets/images/digital/downloadicon/'+item.icontype+'.png')"/>
                                </div>
                                <div v-if="isEdit" class="file-edit-opts">
                                    <img class="file-btn-icon" src="../../assets/images/digital/file-delete.png" @click="handleDeleteFile(index)"/>
                                    <el-upload
                                        action="#"
                                        :auto-upload="false"
                                        :show-file-list="false"
                                        accept="application/*,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                                        :on-change="handleChangeFile">
                                        <img class="file-btn-icon" src="../../assets/images/digital/file-update.png" @click="setCurrentChangeFile(index)"/>
                                    </el-upload>
                                </div>
                                <img v-else class="file-btn-icon" src="../../assets/images/digital/file-download.png" @click="handleDownloadFile(item)"/>
                                <span>{{item.createTime?getDateStr(item.createTime*1000):getDateStr(item.lastModifiedDate)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PreviewDialog v-if="previewIndex>-1" :currIndex="previewIndex" :previewList="previewList"></PreviewDialog>
    </div>
</template>

<script>
import PreviewDialog from '../digitalGeneralCommon/PreviewDialog'
import { mapState } from 'vuex'
export default {
    name: "DetailEdit",
    components: { PreviewDialog },
    props: {
        columnGroupData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        rowData: {
            type: String,
            default: () => {
                return '';
            }
        }
    },
    data() {
        return {
            isEdit: false,
            rowInfo: {},
            formData: {},
            picLoading: false,
            fileLoading: false,
            picList: [],
            fileList: [],
            previewIndex: -1, //预览指针
            previewList: null //详情预览列表
        }
    },
    created() {
        this.getRowInfoAxios()
    },
    computed: {
        ...mapState("gisData",{
            authEdit: state => state.authEdit
        })
    },
    methods: {
        //获取选中行数据
        getRowInfoAxios() {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/indicatorSummary/info`
            this.$common.getTokenRequest()
            .get(url + '?lotNumber='+_this.rowData)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.rowInfo = data.data;
                    _this.formData = JSON.parse(JSON.stringify(_this.rowInfo))
                    _this.initAttachment()
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/indicatorSummary/info')
            })
        },
        //附件分类
        initAttachment() {
            let pics = []
            let files = []
            if(this.rowInfo && this.rowInfo.attachment) {
                pics = this.rowInfo.attachment.filter( item => item.type.indexOf("image/") > -1 || item.type.indexOf("video/") > -1 )

                files = this.rowInfo.attachment.filter( item => item.type.indexOf("application/") > -1 || item.type.indexOf("text/plain") > -1 )
                files = files.map( item => {
                    item.icontype = this.$common.getFileIcontype(item.type)
                    return item;
                });
            }
            this.picList = pics
            this.fileList = files
        },
        //时间格式化
        getDateStr(time) {
            let dt = new Date(time)
            let year = dt.getFullYear()
            let month = dt.getMonth() + 1
            let dat = dt.getDate()
            month = month.toString().padStart(2, "0")
            dat = dat.toString().padStart(2, "0")
            let hour = dt.getHours()
            hour = hour.toString().padStart(2, "0")
            let minute = dt.getMinutes()
            minute = minute.toString().padStart(2, "0")
            let second = dt.getSeconds()
            second = second.toString().padStart(2, "0")
            let finalStr = `${year}-${month}-${dat} ${hour}:${minute}:${second}`;
            return finalStr;
        },
        //关闭详情页
        handleClose(isFresh) {
            this.$parent.handleCloseEdit(isFresh);
        },
        //打开编辑功能
        handleEdit() {
            this.isEdit = true
        },
        //取消编辑功能
        handleEditCancel() {
            this.isEdit = false
            this.formData = JSON.parse(JSON.stringify(this.rowInfo))
            this.initAttachment()
        },
        //保存数据
        handleSave() {
            this.isEdit = false
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/indicatorSummary/edit`
            let picids = this.picList.map(item => item.id)
            let fileids = this.fileList.map(item => item.id)
            let params = {
                ...this.formData,
                attachment: [...picids, ...fileids]
            }
            this.$common.getTokenRequest().put(url, params)
            .then(res=>{
                if(res.data.code===0) {
                   this.$message({
                        duration: 2000,
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.handleClose(true)
                }
            }).catch(err=>{
                console.log(err,'===/v1/digital/indicatorSummary/edit')
            })
        },
        //文件上传服务器
        submitUploadFile(file, type) {
            // console.log(file)
            //判断是否大于100M
            if(file.size / 1024 / 1024 > 100) {
                return;
            }
            if(type==='pic') {
                this.picLoading = true
            } else {
               this.fileLoading = true
            }
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/filemgt/upload`
            let data = new FormData();
            data.append("file", file);
            data.append("group", _this.rowData.lotNumber);

            this.$common.getTokenRequest().post(url, data, {
                onUploadProgress: progressEvent => {
                    // let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
                    // self.uploadMessage = '上传 ' + complete
                    if(progressEvent.loaded < progressEvent.total) {
                        if(type==='pic') {
                            if(!this.picLoading) {
                                this.picLoading = true
                            }
                        } else {
                            if(!this.fileLoading) {
                                this.fileLoading = true
                            }
                        }
                    }
                }
            })
            .then(res=>{
                if(res.data.code===0) {
                    file.id = res.data.data.id
                    file.url = res.data.data.url
                    if(type==='pic') {
                        _this.picLoading = false
                        _this.picList.unshift(file)
                    } else if(type==='file') {
                        _this.fileLoading = false
                        _this.fileList.unshift(file)
                    } else if(type==='change') {
                        _this.fileLoading = false
                        _this.fileList.splice(_this.currentFileIndex, 1, file)
                    }
                }
            }).catch(err=>{
                _this.fileLoading = false
                console.log(err,'===/v1/digital/filemgt/upload')
            })
        },
        //上传多媒体文件
        handleUploadPic(file) {
            this.submitUploadFile(file.raw, 'pic')
            // file.url = URL.createObjectURL(file.raw);
            // this.picList.unshift(file)
        },
        //删除多媒体文件
        handleDeletePic(index) {
            this.picList.splice(index, 1)
        },
        //上传文件
        handleUploadFile(file) {
            let newfile = file.raw
            newfile.icontype = this.$common.getFileIcontype(newfile.type)
            this.submitUploadFile(newfile, 'file')
        },
        //当前替换文件索引
        setCurrentChangeFile(index) {
            this.currentFileIndex = index
        },
        //替换文件
        handleChangeFile(file) {
            let newfile = file.raw
            newfile.icontype = this.$common.getFileIcontype(newfile.type)
            this.submitUploadFile(newfile, 'change')
        },
        //删除文件
        handleDeleteFile(index) {
            this.fileList.splice(index, 1)
        },
        //下载文件
        handleDownloadFile(item) {
            this.$axios
            .get(item.url, {responseType: 'blob'})
            .then(res => {
              if (res.status === 200) {
                this.$common.downloadFileStream(res.data, item.name)
              }
            }).catch(err=>{
              console.log(err,'下载失败')
            })
        },
        //点击预览事件
        handlePreviewClick(index, type) {
            this.previewIndex = index
            if(type==='pic') {
                this.previewList = this.picList
            } else {
                this.previewList = this.fileList
            }
        },
        //关闭预览
        handleClosePreview() {
            this.previewIndex = -1
            this.previewList = null
        }
    }
}
</script>

<style lang="scss" scoped>
.detailEdit-panel {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 11;
    .detailEdit-box {
        position: absolute;
        width: 80%;
        height: 84%;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        padding: 0 20px 20px 60px;
        .box-oprerate {
            position: absolute;
            width: 270px;
            height: 48px;
            top: 20px;
            right: 20px;
            display: flex;
            justify-content: space-between;
            .btn {
                width: 124px;
                height: 100%;
                color: #fff;
                font-size: 20px;
                font-family: SourceHanSansCN;
                font-weight: 400;
                background: #2899FF;
                &:last-child{
                    background: #232323;
                }
            }
            .btn1 {
                position: absolute;
                right: 0;
            }
        }
        .title {
            position: relative;
            margin-top: 70px;
            width: 100%;
            line-height: 40px;
            font-size: 22px;
            font-family: SourceHanSansCN-Bold;
            font-weight: bold;
        }
        .form {
            position: relative;
            width: 100%;
            height: 88%;
            overflow-y: auto;
            .form-group {
                width: 100%;
                margin: 6px 0;
                .name {
                    width: 100%;
                    line-height: 20px;
                    font-size: 15px;
                    font-weight: bold;
                    font-family: SourceHanSansCN-Bold;
                    margin-bottom: 6px;
                }
                .tip-limit {
                    font-size: 13px;
                    color: red;
                    margin-bottom: 6px;
                }
                .content {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    .content-item {
                        width: 200px;
                        height: 70px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: flex-start;
                        color: #424242;
                        margin: 0 20px 4px 0;
                        .input {
                            width: 100%;
                            height: 48px;
                            /deep/ .el-input__inner {
                                border: 1px solid #000;
                                background-color: rgba(255, 255, 255, 0.12);
                                border-radius: 2px;
                                height: 48px;
                                line-height: 48px;
                                color: #424242;
                                font-size: 17px;
                            }
                        }
                        .input-disable {
                            /deep/ .el-input__inner {
                                border: 1px solid #acacac;
                                background-color: #f7f7f7;
                                border-radius: 2px;
                                height: 48px;
                                line-height: 48px;
                                color: #424242;
                                font-size: 17px;
                            }
                        }
                        .select {
                            width: 100%;
                            height: 48px;
                            /deep/.el-input__inner {
                                border: 1px solid #000;
                                background-color: #fff;
                                border-radius: 2px;
                                height: 48px!important;
                                line-height: 48px;
                                color: #424242;
                                font-size: 17px;
                            }
                            /deep/.el-input__suffix {
                                color: #000;
                                height: 48px;
                            }
                            /deep/.select-options {
                                background: #fff;
                                border: solid 1px #000;
                                .el-select-dropdown__item.selected {
                                    font-size: 17px;
                                    color: #424242;
                                }
                                li {
                                    color: #525050;
                                    background: transparent;
                                    font-size: 17px;
                                    height: 26px;
                                    line-height: 26px;
                                }
                                .el-select-dropdown__item:hover,
                                .el-select-dropdown__item.hover {
                                    background-color: transparent;
                                    margin-right: 1px;
                                }
                                .popper__arrow {
                                    border-bottom-color: #000;
                                }
                                .el-select-dropdown__empty {
                                    padding: 20px;
                                    font-size: 17px;
                                }
                            }
                            /deep/ .el-select__caret::before {
                                /*content: "\e78f"*/
                                content: "";
                                background: url('../../assets/images/digital/arrow-down.png') center center no-repeat;
                                position: absolute;
                                width: 100%;
                                height: 100%;
                                appearance: none;// 去除select默认的下拉图标
                                -moz-appearance: none; // 兼容chrome
                                -webkit-appearance: none;// 兼容firefox
                                //使图片箭头向下
                                -webkit-transform: rotate(180deg);/* Safari 和 Chrome */
                                -moz-transform: rotate(180deg);/* Firefox */
                                -o-transform: rotate(180deg);/* Opera */
                                -ms-transform: rotate(180deg);/* IE 9 */
                                transform: rotate(180deg);/* 旋转180度图片 */
                                top: 0%;
                                right: 10%;
                            }
                        }
                    }
                }
                .filelist {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    .filelist-title {
                        font-size: 15px;
                        font-family: SourceHanSansCN;
                        font-weight: 400;
                        color: #424242;
                        margin-bottom: 6px;
                    }
                    .medias {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: flex-start;
                        margin-bottom: 10px;
                        .medias-item {
                            position: relative;
                            width: 90px;
                            height: 60px;
                            margin-right: 8px;
                            .img {
                                width: 100%;
                                height: 100%;
                            }
                            .medias-delete-icon {
                                position: absolute;
                                width: 20px;
                                height: 20px;
                                top: -6px;
                                right: -6px;
                                cursor: pointer;
                            }
                            video {
                                width: 100%;
                                height: 100%;
                                cursor: pointer;
                                object-fit: fill;//消除留白
                            }
                            .icon-play {
                                position: absolute;
                                width: 46px;
                                height: 46px;
                                left: 50%;
                                top: 50%;
                                transform: translate(-50%, -50%);
                            }
                        }
                    }
                    .files {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: flex-start;
                        .file-item {
                            width: 62%;
                            height: 34px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 14px;
                            font-family: SourceHanSansCN-Medium;
                            font-weight: 600;
                            color: #424242;
                            .file-btn-icon {
                                width: 20px;
                                height: 20px;
                                cursor: pointer;
                            }
                            .file-name {
                                width: 40%;
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                .file-type-icon {
                                    width: 20px;
                                    height: 20px;
                                    margin-left: 16px;
                                }
                            }
                            .file-edit-opts {
                                width: 90px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                            }
                        }
                    }
                }
            }
        }
        .form::-webkit-scrollbar {
            width: 10px;
        }
        .form::-webkit-scrollbar-thumb {
           background-color: #DFDFDF;
           border-radius: 5px;
        }
        .form::-webkit-scrollbar-track-piece {
            background: #fff;
        }
    }
}
</style>
<style lang="scss">
.pic-uploader-icon {
    font-size: 26px;
    font-weight: bold;
    color: #fff;
    width: 90px;
    height: 60px;
    line-height: 60px;
    background: #B2B7C3;
    text-align: center;
}
.file-uploader-btn {
    width: 188px;
    height: 40px;
    background: #B2B7C3;
    border-radius: 2px;
    font-size: 14px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 600;
    color: #fff;
}
.file-uploader-btn:hover, .file-uploader-btn:focus {
    background: #B2B7C3;
    color: #fff;
}
</style>